import classnames from 'classnames';
import { bool, node, string } from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';

export default function CreativesMediaSet({
  name,
  children,
  compact,
  ...props
}) {
  const bodyClasses = classnames(
    'd-flex flex-wrap align-items-center justify-content-center',
    {
      'px-3 pt-3 pb-2': !compact,
      'p-2': compact,
    },
  );

  const headerClasses = classnames('small', {
    'px-3 py-2': !compact,
    'p-2': compact,
  });

  return (
    <Card {...props}>
      <CardHeader className={headerClasses}>Media Set - {name}</CardHeader>
      <CardBody className={bodyClasses}>{children}</CardBody>
    </Card>
  );
}

CreativesMediaSet.propTypes = {
  name: string.isRequired,
  children: node.isRequired,
  compact: bool,
};

CreativesMediaSet.defaultProps = {
  compact: false,
};
